export const LAYOUT_XS = 400
export const LAYOUT_SM = 576
export const LAYOUT_MD = 768
export const LAYOUT_LG = 992
export const LAYOUT_XL = 1200
